// extracted by mini-css-extract-plugin
module.exports = {"box":"_id__box__OE2Xv","boxTitle":"_id__boxTitle__fuAk7","dl":"_id__dl__Ptx4V","dt":"_id__dt__q53Bl","dd":"_id__dd__BatPi"};